import { useQuery } from '@apollo/client';
import * as OrganizationQuery from 'graphql/organization.graphql';
import useShouldShowTapToPay from './useShouldShowTapToPay';
import useUserSession from './useUserSession';
import { checkUserRole } from 'components/ProtectedComponent';
import { GetOrganization } from 'api/data/user/types';

const usePermittedSessionPreferences = (spaceSlug: string) => {
  const { data: userSession } = useUserSession();
  const { data: organizationData } = useQuery<GetOrganization>(OrganizationQuery.GetOrganization, {
    variables: { currentSpace: spaceSlug },
  });
  const showTapToPay = useShouldShowTapToPay(organizationData?.organization.provider);

  const sessionPreferences = userSession?.session.sessionPreferences;
  const organization = organizationData?.organization;
  const hasPermission = checkUserRole('MANAGE_IN_PERSON_PAYMENTS', organization?.currentUserRole);
  const hasInPersonPermissionInWebView = showTapToPay;
  const hasInPersonPaymentsPermission = Boolean(
    hasPermission && (organization?.hasPaymentTerminals || hasInPersonPermissionInWebView),
  );

  return {
    canAcceptInPersonPayments: Boolean(hasInPersonPaymentsPermission && sessionPreferences?.acceptInPersonPayments),
    acceptInPersonPayments: !!sessionPreferences?.acceptInPersonPayments,
    hasInPersonPaymentsPermission,
    acceptCashAndCheckPayments: !!sessionPreferences?.acceptCashAndCheckPayments,
    connectedPaymentTerminal: sessionPreferences?.connectedPaymentTerminal,
    tapToPay: !!sessionPreferences?.tapToPay,
  };
};

export default usePermittedSessionPreferences;
